import { OnInit, Input, Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'iw-color-row',
  template: '<button *ngIf="value.color && value.color.valor" [style]="style" class="btn btn-xs" [ngClass]="cssClass">{{value.color.valor}} ' +
            '</button>',
  styles: [`
        .btn-xs {
          font: 400 15px Arial !important;
        }
    `]
})
export class ColorRowTableComponent implements ViewCell, OnInit {
  // entrada del valor del color
  @Input() value: any;
  // entrada de la fila a la cual se le dio click
  @Input() rowData: any;
  // Cambiar clase
  cssClass = 'btn-success';
  // contiene el valor de entrada
  renderValue: any;
  // Determina para mostrar
  sw = false;
  // Define cuando se bloquea o desbloquea el boton de descarga
  disabledDowload = true;
  // estilo del botónn
  style: any;


  constructor(private sanitizer: DomSanitizer){}

  async ngOnInit() {
    this.renderValue = this.value;
    if (this.renderValue && this.renderValue.color) {
      this.renderValue.color.rango.forEach((r: any) => {
        let condicion = r.condicion
        let operacion = r.operacion
        let data = this.renderValue.color.datos;
        if (data && r.condicion_aplica_alias){
          if (data && r.condicion_aplica_alias && data[r.condicion_aplica_alias] && r.condicion_aplica_valor && data[r.condicion_aplica_alias] == r.condicion_aplica_valor){
            if (r.condicion_aplica_alias_dos){
              if (r.condicion_aplica_alias_dos && data[r.condicion_aplica_alias_dos] && r.condicion_aplica_valor_dos &&  r.condicion_aplica_valor_dos == data[r.condicion_aplica_alias_dos]){
                if(operacion == '>' && condicion !== 'and'){
                  if(this.renderValue.color.valor > r.valor_dos && this.renderValue.color.valor < r.valor){
                    this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
                  }
                }
                if(operacion == '>=' && condicion !== 'and'){
                  if(this.renderValue.color.valor >= r.valor_dos && this.renderValue.color.valor < r.valor){
                    this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
                  }
                }
                if(operacion == '<' && condicion !== 'and'){
                  if(this.renderValue.color.valor < r.valor_dos && this.renderValue.color.valor < r.valor){
                    this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
                  }
                }if(operacion == '<=' && condicion !== 'and'){
                  if(this.renderValue.color.valor <= r.valor_dos && this.renderValue.color.valor < r.valor){
                    this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
                  }
                }
                if(operacion == '=' && condicion !== 'and'){
                  if(this.renderValue.color.valor == r.valor_dos || this.renderValue.color.valor == r.valor){
                    this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
                  }
                }
                if(operacion == '!=' && condicion !== 'and'){
                  if(this.renderValue.color.valor !== r.valor_dos || this.renderValue.color.valor !== r.valor){
                    this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
                  }
                }
              }
            }
            else{
              if(operacion == '>' && condicion !== 'and'){
                if(this.renderValue.color.valor > r.valor_dos && this.renderValue.color.valor < r.valor){
                  this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
                }
              }
              if(operacion == '>=' && condicion !== 'and'){
                if(this.renderValue.color.valor >= r.valor_dos && this.renderValue.color.valor < r.valor){
                  this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
                }
              }
              if(operacion == '<' && condicion !== 'and'){
                if(this.renderValue.color.valor < r.valor_dos && this.renderValue.color.valor < r.valor){
                  this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
                }
              }if(operacion == '<=' && condicion !== 'and'){
                if(this.renderValue.color.valor <= r.valor_dos && this.renderValue.color.valor < r.valor){
                  this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
                }
              }
              if(operacion == '=' && condicion !== 'and'){
                if(this.renderValue.color.valor == r.valor_dos || this.renderValue.color.valor == r.valor){
                  this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
                }
              }
              if(operacion == '!=' && condicion !== 'and'){
                if(this.renderValue.color.valor !== r.valor_dos || this.renderValue.color.valor !== r.valor){
                  this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
                }
              }
            }
        }
        }
        else{
          if(operacion == '>' && condicion !== 'and'){
            if(this.renderValue.color.valor > r.valor_dos && this.renderValue.color.valor < r.valor){
              this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
            }
          }
          if(operacion == '>=' && condicion !== 'and'){
            if(this.renderValue.color.valor >= r.valor_dos && this.renderValue.color.valor < r.valor){
              this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
            }
          }
          if(operacion == '<' && condicion !== 'and'){
            if(this.renderValue.color.valor < r.valor_dos && this.renderValue.color.valor < r.valor){
              this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
            }
          }if(operacion == '<=' && condicion !== 'and'){
            if(this.renderValue.color.valor <= r.valor_dos && this.renderValue.color.valor < r.valor){
              this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
            }
          }
          if(operacion == '=' && condicion !== 'and'){
            if(this.renderValue.color.valor == r.valor_dos || this.renderValue.color.valor == r.valor){
              this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
            }
          }
          if(operacion == '!=' && condicion !== 'and'){
            if(this.renderValue.color.valor !== r.valor_dos || this.renderValue.color.valor !== r.valor){
              this.style = this.sanitizer.bypassSecurityTrustStyle(`background-color: ${r.color} !important`);
            }
          }
        }
        
        
      });
      this.disabledDowload = false;
      this.cssClass = 'background: black !important'
    } else {
      this.cssClass = 'btn-secondary';
    }
    
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/color-row-table.component.ts